<div class="container">
  <div class="breadCrumb d-none d-sm-flex">
    <div class="step1" [ngClass]="{'active': step==1,'inactive': step==2}" (click)="goToStep(1)">
      <div class="circle">1</div>
      <h4>ADD {{LABEL.PATIENT}} DETAILS</h4>
    </div>
    <span>
      <!-- <fa name="chevron-right" size="2x"></fa> -->
    </span>
    <div class="step2" [ngClass]="{'active': step==2,'inactive': step==1}" (click)="goToStep(2)">
      <div class="circle">2</div>
      <h4>ADD PAYMENT DETAILS</h4>
    </div>
  </div>
  <div class="bannerDiv VHAlign w-100 d-flex d-sm-none">
    <div class="step1 col-7" [ngClass]="{'active': step==1,'inactive': step==2}" (click)="goToStep(1)">
      <h5 class="m-0">ADD {{LABEL.PATIENT}} DETAIL</h5>
    </div>
    <div class="step2 col-5" [ngClass]="{'active': step==2,'inactive': step==1}" (click)="goToStep(2)">
      <h5 class="m-0">ADD PAYMENT</h5>
    </div>
  </div>
  <div class="row flex-row-reverse">
    <button class="btn btnDefault mb-4 me-4" style="border-radius: 4rem" (click)="goBack()">Back</button>
  </div>
  <div class="row mobileFormDiv">
    <h3 class="col-lg-3 col-md-3 col-sm-12 col-12 m-0 p-b-10 p-t-20" [hidden]="step === 2">Add Details</h3>
    <h3 class="col-lg-3 col-md-3 col-sm-12 col-12 m-0 p-b-10 p-t-20" [hidden]="step === 1">Payment</h3>
    <div class="col-lg-9 col-md-9 col-sm-12 col-12 pull-right">
      <div class="row" style="flex-direction: row-reverse;">

        <div class="col-md-4 col-sm-6 col-lg-4 greenDiv">
          <h4 class="m-b-5">
            <span *ngIf="mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount)">
              ${{financeData.recurring_amount +
              mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount)
              |DynamicDecimalPipe:mainService.currency_data.currency_code}} <i class="fa fa-info-circle m-l-5"
                placement="right" tooltip='Your recurring amount includes a transaction fee.'></i></span>
            <!-- <span *ngIf="mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount)">
                ${{financeData.recurring_amount + mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount) |number:'0.2-2'}}
                (${{financeData.recurring_amount|number:'0.2-2'}} +
                ${{mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount) | number:'0.2-2'}})</span> -->
            <span *ngIf="!mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount)">
              ${{financeData.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}} </span>
          </h4>
          <span *ngIf="!(financeData.advance_interest_amount && contract_type == 1)">Payment to be made for next
            {{financeData.number_of_payments}} months</span>
          <span *ngIf="financeData.advance_interest_amount && contract_type == 1">Payment to be made for next
            {{financeData.number_of_payments - 1}} months</span>
        </div>
        <div class="col-md-4 col-sm-6 col-lg-4 whiteDiv">
          <h4 class="m-b-5">$ {{financeData.financed_amount}}</h4>
          <span> at {{financeData.interest_rate_to_show || financeData.interest_rate}}% interest rate</span>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="panel panel-default">
    <div class="panel-body formDiv">
      <app-personal [hidden]="step === 2" (formEvent)="updatePatientData($event)"></app-personal>
      <app-payment [hidden]="step === 1"></app-payment>
    </div>
  </div>
</div>